export default __webpack_public_path__ + "static/img/plane-departure.46df3ad.png";